module.exports = __webpack_public_path__ + "img/gray_light_marker3.8830d734.svg";